/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCompanies200ResponseInner
 */
export interface GetCompanies200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    taxId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCompanies200ResponseInner
     */
    entityType?: string;
}

/**
 * Check if a given object implements the GetCompanies200ResponseInner interface.
 */
export function instanceOfGetCompanies200ResponseInner(value: object): value is GetCompanies200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetCompanies200ResponseInnerFromJSON(json: any): GetCompanies200ResponseInner {
    return GetCompanies200ResponseInnerFromJSONTyped(json, false);
}

export function GetCompanies200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanies200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : json['address'],
        'id': json['id'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'name': json['name'] == null ? undefined : json['name'],
        'taxId': json['taxId'] == null ? undefined : json['taxId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function GetCompanies200ResponseInnerToJSON(json: any): GetCompanies200ResponseInner {
    return GetCompanies200ResponseInnerToJSONTyped(json, false);
}

export function GetCompanies200ResponseInnerToJSONTyped(value?: GetCompanies200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'id': value['id'],
        'locationId': value['locationId'],
        'name': value['name'],
        'taxId': value['taxId'],
        'entityType': value['entityType'],
    };
}

